export const EXHIBITION_CATEGORIES = `
  query exhibitionCategories($filter: FilterExhibitionCategoryInput, $tenant_id: Int!) {
    exhibitionCategories(filter: $filter, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionCategory {
        id
        name
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EXHIBITION_CATEGORY = `
  query exhibitionCategory($id: Int!, $tenant_id: Int!) {
    exhibitionCategory(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionCategory {
        id
        name
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
